import React, { useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import { Button } from "@material-ui/core";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { CloseBoxActions } from "../../../Actions/ProductionActions";
import Loading from "../../Loading/Loading";
import secureLocalStorage from "react-secure-storage";

const ConfirmationDialog = ({
  close,
  title,
  description,
  inventory_id,
  handleRefresh,
}) => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const dispatch = useDispatch();

  //   Close Box State
  const { close_box, loading } = useSelector((state) => state.ClosingBox);

  const [isClosed, setIsClosed] = useState(false);

  const handleCloseBox = () => {
    setIsClosed(true);
    dispatch(CloseBoxActions("inventory_close_box", inventory_id, token));
  };

  useEffect(() => {
    if (close_box && close_box?.status === 1 && isClosed) {
      toast.success("Box Closed Successfully");
      setIsClosed(false);

      let pdfFile = close_box && close_box?.pdf_file;
      if (pdfFile && pdfFile !== "") {
        window.open(pdfFile, "_blank", "noopener,noreferrer");
      } else {
        toast.error("No PDF File Found");
      }

      handleRefresh();
    } else if (close_box && close_box?.status === 0 && isClosed) {
      toast.error(close_box && close_box?.msg);
      setIsClosed(false);
    }
    // eslint-disable-next-line
  }, [close_box, isClosed]);
  return (
    <>
      <HeadingTitle title={title} center={false} closeModal={close} />
      <div className="confirmation-box-row">
        <p
          style={{
            fontFamily:
              title === "Create Box" || title === "Alert" ? "Poppins_Bold" : "",
          }}
        >
          {description === "Please Close Previous Box firstly"
            ? "Before creating a new box, could you please close the previous one?"
            : description}
        </p>
        {title !== "Create Box" && title !== "Alert" ? (
          <div className="confirmation-container">
            <Button onClick={handleCloseBox}>
              {loading ? <Loading loading={loading} /> : "Yes"}
            </Button>
            <Button onClick={close}>No</Button>
          </div>
        ) : (
          <div className="closing-no">
            <Button onClick={close}>Okay</Button>
          </div>
        )}
      </div>
    </>
  );
};

export default ConfirmationDialog;
